import { FC, useMemo } from 'react';
import { Box, Divider, Grid, GridItem, Heading, StackDivider, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CodeTextarea } from '@netiva/classifieds-ui';

import { ApiBaseUrl } from '@/environment';
import { useAppSelector } from '@/store';
import { getDivCode } from '../utils';
import { CommonFormControls } from './CommonFormControls';

export type ListDetailConfigurationProps = {
  loaderScriptCode: string;
};

export const ListDetailConfiguration: FC<ListDetailConfigurationProps> = ({ loaderScriptCode }) => {
  const { t } = useTranslation();

  const { filter, params, theme } = useAppSelector((state) => state.sdk);

  const integrationCode = useMemo(() => {
    if (!params.platform) {
      return '';
    }
    return getDivCode({
      apiUrl: ApiBaseUrl,
      component: 'listDetail',
      type: 'iframe',
      filter: filter ? JSON.stringify(filter) : '',
      theme: theme ? JSON.stringify(theme) : '',
      language: params.language,
      platform: params.platform,
      recaptcha: 'true',
    });
  }, [filter, params.language, params.platform, theme]);

  return (
    <VStack align="stretch" divider={<StackDivider />} spacing={8}>
      <div>
        <Heading fontSize="lg" my={2}>
          {t('sdk.listDetail.title')}
        </Heading>
        <VStack align="stretch" spacing={4}>
          <CommonFormControls />
        </VStack>
      </div>
      <div>
        <Heading fontSize="lg" my={2}>
          {t('sdk.code.title')}
        </Heading>
        <Grid templateColumns={{ base: '1fr', lg: 'minmax(0,1fr) auto minmax(0,1fr)' }} gap={4}>
          <GridItem>
            <div>
              <Text mb={2}>{t('sdk.scriptCode.helpText')}</Text>
              <CodeTextarea value={loaderScriptCode} height={70} />
            </div>
            <Box width="full" mt={4}>
              <Text mb={2}>{t('sdk.divCode.helpText')}</Text>
              <CodeTextarea value={integrationCode} height={160} />
            </Box>
          </GridItem>
          <GridItem display={{ base: 'none', lg: 'unset' }}>
            <Divider orientation="vertical" />
          </GridItem>
          <GridItem>
            <Text mb={2}>{t('sdk.preview')}</Text>
            <Box dangerouslySetInnerHTML={{ __html: integrationCode }} width="full" border="default" padding={2}></Box>
          </GridItem>
        </Grid>
      </div>
    </VStack>
  );
};
